import Image from 'next/image';

export default function StaticClientsPartners() {
  const logos = [
    { src: "/images/logos/AALogo.svg", alt: "American Airlines", width: 160, height: 40, widthMobile: 112, heightMobile: 17 },
    { src: "/images/logos/citi.svg", alt: "Citi", width: 100, height: 40, widthMobile: 38, heightMobile: 22 },
    { src: "/images/logos/exchange-logo.svg", alt: "EXCHANGE", width: 140, height: 40, widthMobile: 75, heightMobile: 18 },
    { src: "/images/logos/goodrxlogo.svg", alt: "GoodRx", width: 120, height: 40, widthMobile: 74, heightMobile: 15 },
    { src: "/images/logos/google-fitbit.svg", alt: "Google Fitbit", width: 150, height: 40, widthMobile: 71, heightMobile: 13 },
    { src: "/images/logos/thos.svg", alt: "THE HOUSE OF SUNTORY", width: 200, height: 40, widthMobile: 150, heightMobile: 9 },
    { src: "/images/logos/lfglogo.svg", alt: "Lincoln Financial", width: 160, height: 40, widthMobile: 58, heightMobile: 20 },
    { src: "/images/logos/nyplogo.svg", alt: "NewYork-Presbyterian", width: 180, height: 40, widthMobile: 127, heightMobile: 14 },
    { src: "/images/logos/nttdata.svg", alt: "NTT DATA", width: 120, height: 40, widthMobile: 72, heightMobile: 14 },
  ];

  return (
    <section className="">
      <div className="mx-auto">
        {/* Desktop: 2 Rows - 5 logos in first row, 4 in second row */}
        <div className="hidden md:block pt-[2.6875rem]">
          {/* First row - 5 logos */}
          <div className="grid grid-cols-5 gap-8 items-center justify-items-center mb-8">
            {logos.slice(0, 5).map((logo, index) => (
              <div key={index} className="flex items-center justify-center p-4">
                <Image
                  src={logo.src}
                  alt={logo.alt}
                  width={logo.width}
                  height={logo.height}
                  className="max-w-full h-auto object-contain filter brightness-0"
                  style={{ width: 'auto', height: 'auto' }}
                />
              </div>
            ))}
          </div>
          
          {/* Second row - 4 logos */}
          <div className="grid grid-cols-4 gap-8 items-center justify-items-center">
            {logos.slice(5, 9).map((logo, index) => (
              <div key={index + 5} className="flex items-center justify-center p-4">
                <Image
                  src={logo.src}
                  alt={logo.alt}
                  width={logo.width}
                  height={logo.height}
                  className="max-w-full h-auto object-contain filter brightness-0"
                  style={{ width: 'auto', height: 'auto' }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Mobile: 3x3 Grid */}
        <div className="md:hidden grid grid-cols-3 gap-4 items-center justify-items-start pt-[1.25rem]">
          {logos.map((logo, index) => {
            const columnPosition = index % 3;
            const justifySelfClass = 
              columnPosition === 1 ? 'justify-self-center' : 
              columnPosition === 2 ? 'justify-self-end' : 
              '';
            
            return (
              <div key={index} className={`flex items-center justify-center p-2 ${justifySelfClass}`}>
                <Image
                  src={logo.src}
                  alt={logo.alt}
                  width={logo.widthMobile}
                  height={logo.heightMobile}
                  className="max-w-full h-auto object-contain filter brightness-0"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
